import React from 'react';
import { ModalProvider } from "react-modal-hook";
import { ProgressProvider } from './progress';
import { AuthProvider } from './auth';
import GoogleProvider from './useAuthGoogle/Context';

interface AppProviderProps {
    children?: React.ReactNode;
  }

const AppProvider: React.FC<AppProviderProps> = ({ children }) => (
     <ProgressProvider>
        <GoogleProvider>
            <ModalProvider>
                <AuthProvider>{children}</AuthProvider>
            </ModalProvider>
        </GoogleProvider>
    </ProgressProvider>
 );

export default AppProvider;
